import { blockNodePositioner, Positioner } from '@remirror/extension-positioner';
import { findParentNodeOfType, findParentNode } from '@remirror/core';

const cellNodeTypes = ['tableCell', 'tableHeaderCell'];

function isLastColumn(selection) {
  if (!selection) return false;

  const path = selection.$head.path;
  const cellPositionIndex =
    (path?.findIndex((value) => typeof value === 'object' && value.type.name === 'tableRow') ?? -1) + 1;
  const cellPosition = path?.at(cellPositionIndex);
  const tableRowChildCount = path.at(cellPositionIndex - 1)?.childCount;
  return tableRowChildCount - 1 === cellPosition;
}

// When the selection is a CellSelection and there is only one cell in the selection, return the cell.
function findMenuTableCell(selection) {
  // If the selection is a CellSelection, then we show the cell menu inside the head cell.
  if (selection) {
    const menuTableCell = findParentNodeOfType({ selection: selection.$head, types: cellNodeTypes });
    return { ...menuTableCell, isLastMenuCell: isLastColumn(selection) };
  }
  const menuTableCell = findParentNodeOfType({ selection: selection, types: cellNodeTypes });
  return { ...menuTableCell, isLastMenuCell: isLastColumn(selection) };
}

/**
 * Creates a positioner for the current table cell node which will show the
 * cell menu.
 *
 * It spans the full width and height of the table cell node.
 */
export const menuCellPositioner = blockNodePositioner.clone(() => ({
  getActive: (props) => {
    const result = findMenuTableCell(props.state.selection);
    return result ? [result] : Positioner.EMPTY;
  },
}));
